import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const CustomizeTab = ({ customization = {}, onCustomizationChange = () => {}, colorPalettes = {} }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-2 mb-3">
                    <label className="form-label fs-6" htmlFor="theme-select">Theme</label>
                    <select
                        id="theme-select"
                        className="form-select"
                        value={customization.theme || "light"}
                        onChange={(e) => onCustomizationChange("theme", e.target.value)}
                    >
                        <option value="light">Light</option>
                        <option value="dark">Dark</option>
                    </select>
                </div>
                <div className="col-md-2 mb-3">
                    <label className="form-label">Color Palette</label>
                    <select
                        className="form-select"
                        value={customization.colorPalette || "Plotly"}
                        onChange={(e) => onCustomizationChange("colorPalette", e.target.value)}
                    >
                        {colorPalettes && Object.keys(colorPalettes).length > 0 ? (
                            Object.keys(colorPalettes).map((palette) => (
                                <option key={palette} value={palette}>
                                    {palette === "Plotly" ? "Plotly Default" : palette}
                                </option>
                            ))
                        ) : (
                            <option value="" disabled>No palettes available</option>
                        )}
                    </select>
                </div>
                <div className="col-md-2 mb-3">
                    <label className="form-label">Graph Type</label>
                    <select
                        className="form-select"
                        value={customization.graphType || "scatter"}
                        onChange={(e) => onCustomizationChange("graphType", e.target.value)}
                    >
                        <option value="scatter">Scatter</option>
                        <option value="line">Line</option>
                        <option value="density">Density Histogram</option>
                        <option value="facet">Faceted Scatter</option>
                    </select>
                </div>
                <div className="col-md-2 mb-3">
                    <label className="form-label">Hover Info</label>
                    <select
                        className="form-select"
                        value={customization.hoverInfo || "x+y+name"}
                        onChange={(e) => onCustomizationChange("hoverInfo", e.target.value)}
                    >
                        <option value="x+y+name">X, Y, and Name</option>
                        <option value="x+y">X and Y</option>
                        <option value="x">X only</option>
                        <option value="y">Y only</option>
                        <option value="text">Text-free</option>
                    </select>
                </div>
                <div className="col-md-2 mb-3">
                    <label className="form-label">Line Style</label>
                    <select
                        className="form-select"
                        value={customization.lineStyle || "solid"}
                        onChange={(e) => onCustomizationChange("lineStyle", e.target.value)}
                    >
                        <option value="solid">Solid</option>
                        <option value="dash">Dashed</option>
                        <option value="dot">Dotted</option>
                        <option value="dashdot">Dash-Dot</option>
                    </select>
                </div>
                <div className="col-md-2 mb-3">
                    <label className="form-label">Marker Style</label>
                    <select
                        className="form-select"
                        value={customization.markerStyle || "circle"}
                        onChange={(e) => onCustomizationChange("markerStyle", e.target.value)}
                    >
                        <option value="circle">Circle</option>
                        <option value="square">Square</option>
                        <option value="diamond">Diamond</option>
                        <option value="cross">Cross</option>
                        <option value="x">X</option>
                    </select>
                </div>
            </div>

            {customization.graphType === "scatter" && (
                <div className="row">
                    <div className="col-md-12 col-lg-5 mb-2">
                        <label className="form-label">Bubble Size</label>
                        <input
                            type="range"
                            className="form-range"
                            min="5"
                            max="30"
                            value={customization.bubbleSize || 5}
                            onChange={(e) => onCustomizationChange("bubbleSize", parseInt(e.target.value))}
                        />
                        <div className="text-center">{customization.bubbleSize || 5}px</div>
                    </div>
                </div>
            )}

            {customization.graphType === "facet" && (
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <label className="form-label">Facet Columns</label>
                        <select
                            className="form-select"
                            value={customization.facetColumns || 2}
                            onChange={(e) => onCustomizationChange("facetColumns", parseInt(e.target.value))}
                        >
                            <option value="1">1 Column</option>
                            <option value="2">2 Columns</option>
                            <option value="3">3 Columns</option>
                        </select>
                    </div>
                </div>
            )}

            {customization.graphType === "density" && (
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <label className="form-label">Density Columns</label>
                        <select
                            className="form-select"
                            value={customization.densityColumns || 2}
                            onChange={(e) => onCustomizationChange("densityColumns", parseInt(e.target.value))}
                        >
                            <option value="1">1 Column</option>
                            <option value="2">2 Columns</option>
                            <option value="3">3 Columns</option>
                        </select>
                    </div>
                </div>
            )}

            <div className="row ">
                <div className="form-check form-switch col-md-2 m-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={customization.showGrid || false}
                        onChange={(e) => onCustomizationChange("showGrid", e.target.checked)}
                    />
                    <label className="form-check-label">Show Grid Lines</label>
                </div>
                <div className="form-check form-switch col-md-2 m-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={customization.showLegend || false}
                        onChange={(e) => onCustomizationChange("showLegend", e.target.checked)}
                    />
                    <label className="form-check-label">Show Legend</label>
                    <span
                        className="ms-1 text-muted"
                        title="See sensors linked to colors below the graph"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        style={{ cursor: "default" }}
                    >
                        <FontAwesomeIcon icon={faCircleInfo} className="fs-6" />
                    </span>
                </div>
                <div className="form-check form-switch col-md-2 m-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={customization.showRawData || false}
                        onChange={(e) => onCustomizationChange("showRawData", e.target.checked)}
                    />
                    <label className="form-check-label">Show Raw Data</label>
                    <span
                        className="ms-1 text-muted"
                        title="Show raw data points on the graph which may slow down rendering for large datasets"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        style={{ cursor: "default" }}
                    >
                        <FontAwesomeIcon icon={faCircleInfo} className="fs-6" />
                    </span>
                </div>
                <div className="form-check form-switch col-md-2 m-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={customization.showFitLines || false}
                        onChange={(e) => onCustomizationChange("showFitLines", e.target.checked)}
                    />
                    <label className="form-check-label">Show Fit Lines</label>
                </div>
            </div>
        </>
    );
};

export default CustomizeTab;